import Vue from 'vue'
import VueRouter from 'vue-router'
import CartWorld from '@/views/CartWorld.vue'

// Vistas principales
import HomeView from '../views/HomeView.vue'
import RedesView from '@/views/RedesView.vue'
import NoticiaView from '@/views/NoticiaView.vue'
import CamaraView from '@/views/CamaraView.vue'
import EmpresaView from '@/views/EmpresaView.vue'
import ContactanosView from '@/views/ContactanosView.vue'
import TelefonoView from '@/views/TelefonoView.vue'
import ComputacionView from '@/views/ComputacionView.vue'
import alarmaVienw from '@/views/alarmaVienw.vue'
import JuegoVienw from '@/views/JuegoVienw.vue'
import ElectronicaView from '@/views/ElectronicaView.vue'
import ImpresoraVienw from '@/views/ImpresoraVienw.vue'
import CatalogoWiel from '@/views/CatalogoWiel.vue'
import ConsultaOrdenView from '@/views/ConsultaOrdenView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/servicio/redes',
    name: 'redes',
    component: RedesView
  },
  {
    path: '/catalogo',
    name: 'catalogo',
    component: CatalogoWiel
  },
  {
    path: '/carrito',
    name: 'cart',  // El nombre 'cart' es importante
    component: CartWorld
  },
  // NUEVA RUTA: Para ver un producto específico
  {
    path: '/producto/:id',
    name: 'producto-detalle',
    component: CatalogoWiel,
    props: true
  },
  {
    path: '/servicio/camaras',
    name: 'camaras',
    component: CamaraView
  },
  {
    path: '/servicio/empresas',
    name: 'empresas',
    component: EmpresaView
  },
  {
    path: '/servicio/moviles',
    name: 'moviles',
    component: TelefonoView
  },
  {
    path: '/servicio/computacion',
    name: 'computacion',
    component: ComputacionView
  },
  {
    path: '/servicio/alarmas',
    name: 'alarmas',
    component: alarmaVienw
  },

  {
    path: '/servicio/juegos',
    name: 'juegos',
    component: JuegoVienw
  },
  {
    path: '/servicio/electronica',
    name: 'electronica',
    component: ElectronicaView
  },
  {
    path: '/servicio/impresora',
    name: 'impresora',
    component: ImpresoraVienw
  },
  {
    path: '/noticias',
    name: 'noticias',
    component: NoticiaView
  },
  {
    path: '/contactanos',
    name: 'contactanos',
    component: ContactanosView
  },
  {
    path: '/consultar-orden',
    name: 'consultar-orden',
    component: ConsultaOrdenView
  },
  {
    path: '/seguimiento-orden',
    redirect: '/consultar-orden'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    }
  }
})

// Solución para el error de navegación duplicada
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

// También para replace
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

export default router